module.exports = __webpack_public_path__ + "img/dropdown-black-icon.8f854878.svg";